import {
  Button,
  Link,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text as ChakraText,
} from '@chakra-ui/react'
import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { colors } from '../../../ui-kit'

interface OriginAddedModalProps {
  isOpenOriginAdded: boolean
  onCloseOriginAdded(): void
}

export const OriginAddedModal = ({
  isOpenOriginAdded,
  onCloseOriginAdded,
}: OriginAddedModalProps): React.ReactElement => {
  const { t } = useTranslation()

  const history = useHistory()

  return (
    <Modal isOpen={isOpenOriginAdded} onClose={onCloseOriginAdded} size="xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t('success', 'Success')}!</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Trans t={t} i18nKey="origin_added_modal_description">
            <ChakraText color={colors.appBattleshipGrey}>
              Your origin has been added successfully! To access images from
              this origin, you need to associate it with a URL-endpoint.{' '}
              <Link
                lineHeight="base"
                href="https://docs.imagekit.io/integration/url-endpoints"
                isExternal
              >
                Learn how to do that
              </Link>
              . To go to the URL-endpoints management page,{' '}
              <Link
                lineHeight="base"
                onClick={() => {
                  history.push('/url-endpoints')
                }}
              >
                click here
              </Link>
              .
            </ChakraText>
          </Trans>
        </ModalBody>
        <ModalFooter borderTop="1px solid #e7eaf0" style={{ gap: '1em' }}>
          <Button onClick={onCloseOriginAdded}>{t('got_it', 'Got it')}</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
